import React, {useEffect, useState} from "react";
import {useRequestState} from "../../hooks/RequestState";
import DocumentViewer from "../../components/DocumentViewer";
import {Container} from "@mui/material";
import {ProposalItem} from "../../models/proposal/Proposal";

const Review = () => {
    const {requestState, updateRequestState} = useRequestState();
    // const [text, setText] = useState("");
    const [item, setItem] = useState<ProposalItem>(new ProposalItem());

    useEffect(() => {
        const markdown = requestState.result ?? "# No data";
        const item: ProposalItem = {
            id: -1,
            uniqueId: "",
            result: markdown
        };
        setItem(item); 
        
    }, [requestState]);
    
    return (
        <Container maxWidth="md" sx={{mt: 4, mb: 4}}>
            <DocumentViewer proposalItem={item} allowDownload={true} />
        </Container>
    );
};


export default Review;